export const MY_RESPONSES_FIELDS_META = {
  responseFilter: {
    title: 'Filter by Project',
    errorMsg: '',
    required: false,
  },
};
